@if (params.data.status !== 'Completed') {
  <input type="checkbox" id="c_{{ params.data.teamMemberId }}" [checked]="checked" (change)="onCheckboxChange($event)" /><label
    class="checkbox-nolabel"
    for="c_{{ params.data.teamMemberId }}"
  ></label>
}
